var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "panel-body text-size-20 font-bold flex" },
      [
        _c("div", { staticClass: "panel-content" }, [
          _vm._v(
            "\n    サービスの変更に伴い、ヤマト運輸倉庫への直接納品は廃止となりました。\n    "
          ),
          _c("br"),
          _vm._v(
            "\n    ヤマト運輸倉庫へ納品したい場合は、以下の手順で実施してください。\n    "
          ),
          _c("br"),
          _vm._v(" "),
          _c("ol", [
            _c("li", [_vm._v("ACROSS倉庫画面を開く")]),
            _vm._v(" "),
            _c("li", [_vm._v("「直接納品」メニューからACROSS倉庫へ納品")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "商品の納品後、「ヤマト運輸倉庫へ出荷」メニューから出荷依頼登録"
              )
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b95eb9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b95eb9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/DeliveryRequestRegistration.vue
// module id = null
// module chunks = 